import { Form } from 'react-bootstrap';

const SubmissionTypeField = ({ value, onChange, isSubmitting }) => (
  <Form.Group as="fieldset" className="mb-3">
    <Form.Label as="legend" className="required-field">
      Submission Type
    </Form.Label>
    <div className="radio-group">
      <Form.Check
        type="radio"
        label="New"
        id="submissionTypeNew"
        value="NEW"
        checked={value === 'NEW'}
        onChange={(e) => onChange(e.target.value)}
        disabled={isSubmitting}
        required
      />
      <Form.Check
        type="radio"
        label="Corrected"
        id="submissionTypeCorrected"
        value="CORRECTED"
        checked={value === 'CORRECTED'}
        onChange={(e) => onChange(e.target.value)}
        disabled={isSubmitting}
      />
    </div>
  </Form.Group>
);

export default SubmissionTypeField;
